import profile from './profile';
import careerProfile from './careerProfile';
import experiences from './experiences';
import projects from './projects';
import tags from './tags';

export const data = {
  profile,
  careerProfile,
  experiences,
  projects,
  tags
};

export default data;
